import Icons from '../../Assets';
import styles from './styles.module.scss';

const Logo: React.FC = () => {
    return <Icons.LogoIcon className={styles.logoIcon} />;
};

export default Logo;
